/* eslint-disable */

import React, { useContext, useState } from 'react';
import { Button, Modal } from 'tt-ui-kit';
import { ReactComponent as Doc } from '../../assets/icons/doc.svg';
import styles from './HelpersFiles.module.scss';
import FileState from '../fileState/FileState';
import { ErrorContext, DraftContext } from '../../context';

const title = 'Files';
const text = `Please add the files used in this project.`;

const HelpersFilesList = (props) => {
  const { filesList } = props;
  const { draftId } = useContext(DraftContext);
  const { setErrorAlert } = useContext(ErrorContext);

  const [filesModalOpen, setFilesModalOpen] = useState(false);

  return (
    <>
      {filesList.length && (
        <>
          <Button type="default" onClick={() => setFilesModalOpen(true)} startIcon={<Doc />}>
            View docs
          </Button>
          <Modal
            open={filesModalOpen}
            onClose={() => setFilesModalOpen(false)}
            className={styles.filesModal}
            title={title}
          >
            <div className={styles.question}>{text}</div>
            <div className={styles.filesWrapper}>
              <div className={styles.filesContainer}>
                {filesList?.length
                  ? filesList.map((file) => <FileState key={file.uuidName} file={file} />)
                  : `No files found for this question`}
              </div>
            </div>
            <div className={styles.buttonBlock}>
              <Button type="default" onClick={() => setFilesModalOpen(false)}>
                Exit
              </Button>
            </div>
          </Modal>
        </>
      )}
    </>
  );
};

export default HelpersFilesList;
